// extracted by mini-css-extract-plugin
export default {"container":"DO-z","topReviewHeading":"EO-z","criticalReview":"FO-z","favorableReview":"GO-z","vsSeparator":"HO-z"};